import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ConsultaProtocolo,
  DadosAtendimento,
  DadosUnidade,
  FormularioBuscaUnidade,
  IdentificacaoAtendimento,
  Municipio,
  Servico,
  ServicoInterno,
} from '../models/Servico.model';
import { BehaviorSubject, map } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ServicoService {

  private servicosInternosSubject = new BehaviorSubject<ServicoInterno[]>([]);
  servicosInternos$ = this.servicosInternosSubject.asObservable();

  constructor(private http: HttpClient) { }

  getServicoBySlug(slug: string) {
    const url = `/api/servicos/${slug}`;
    return this.http.get<Servico>(url);
  }

  getServico(id: number) {
    const url = `/api/servicos/${id}`;
    return this.http.get<Servico>(url);
  }

  getUnidade(filtro: FormularioBuscaUnidade) {
    const url = `/api/v2/unidade/${filtro.cpfCnpjUnidade}/${filtro.matricula}/${filtro.id}`;

    return this.http.get<DadosUnidade>(url);
  }

  getMunicipios() {
    const url = `/api/atendimento/municipios`;

    return this.http.get<Municipio[]>(url);
  }

  postFormularioInterno(formulario: FormData) {
    const url = `/api/interno/atendimento/gravar`;

    return this.http.post<IdentificacaoAtendimento>(url, formulario);
  }

  postFormulario(formulario: FormData) {
    const url = `/api/atendimento/gravar`;

    return this.http.post<IdentificacaoAtendimento>(url, formulario);
  }

  postServicoBuscaJudicial(formulario: FormData) {
    const url = `/api/atendimento/buscajudicial`;
    return this.http.post<IdentificacaoAtendimento>(url, formulario);
  }

  postServicoCredenciamentoCaminhoesLimpaFossa(formulario: FormData) {
    const url = `/api/atendimento/credenciamentocaminhoeslimpafossa`;
    return this.http.post<IdentificacaoAtendimento>(url, formulario);
  }

  postServicoCredenciamentoImobiliaria(formulario: FormData) {
    const url = `/api/atendimento/credenciamentoimobiliaria`;
    return this.http.post<IdentificacaoAtendimento>(url, formulario);
  }

  getDadosAtendimento(id: number, ano: number) {
    const url = `/api/atendimento/${id}/${ano}`;

    return this.http
      .get<DadosAtendimento>(url)
      .pipe(map((dados) => DadosAtendimento.fromResponse(dados)));
  }

  postArquivosComplementares(id: number, ano: number, formulario: FormData) {
    const url = `/api/atendimento/gravar/${id}/${ano}`;

    return this.http
      .post<DadosAtendimento>(url, formulario)
      .pipe(map((dados) => DadosAtendimento.fromResponse(dados)));
  }

  descriptografarToken(token: string): string {
    const bytes = CryptoJS.AES.decrypt(token, environment.HASH);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  criptografarToken(token: string): string {
    return CryptoJS.AES.encrypt(token, environment.HASH).toString();
  }

  getInformacoesProtocolo(protocolo: string) {
    const partes = protocolo.split(' ');
    const data = partes[0];
    const hora = partes[1];
    const matricula = partes[2];

    // Converter a data para o formato dd-mm-yyyy-hh:mm
    const [dia, mes, ano] = data.split('/');
    const dataFormatada = `${dia}-${mes}-${ano}-${hora}`;

    return this.http
      .get<ConsultaProtocolo>(`/api/protocolo/${dataFormatada}/${matricula}`)
      .pipe(map((dados) => ConsultaProtocolo.fromResponse(dados)));
  }

  postLiberarSuspesao(consultaProtocolo: ConsultaProtocolo) {
    const partes = consultaProtocolo.protocoloFormatado.split(' ');
    const data = partes[0];
    const hora = partes[1];

    // Converter a data para o formato dd-mm-yyyy-hh:mm
    const [dia, mes, ano] = data.split('/');
    const dataFormatada = `${dia}-${mes}-${ano}-${hora}`;

    return this.http
      .post<ConsultaProtocolo>(`/api/protocolo/liberar`, {
        data: dataFormatada,
        matricula: consultaProtocolo.matricula,
      })
      .pipe(map((dados) => ConsultaProtocolo.fromResponse(dados)));
  }

  getServicosInternos() {
    if (this.servicosInternosSubject.getValue().length == 0)
      this.http.get<ServicoInterno[]>(`/api/private/servicos-internos`).subscribe({
        next: (data) => {
          this.servicosInternosSubject.next(data);
        }
      })
  }

}
